import { AxiosRequestConfig } from "axios";
import api from "../api-instance";

const ROUTE = "/Faq";

export async function getDownloadFaqRop(): Promise<{
  data: { manualPdfUrl: string; procedimentoManutencaoPreventivaUrl: string };
}> {
  const config: AxiosRequestConfig = {};
  const result = await api.get<{
    manualPdfUrl: string;
    procedimentoManutencaoPreventivaUrl: string;
  }>(`${ROUTE}/download`, config);
  return {
    data: result.data,
  };
}
